import type { RouteComponentProps } from '@reach/router';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import * as ROUTES from '@constants/routes';

import AuthLayout, { BackLink, Subtitle } from '@layouts/AuthLayout';

const messages = defineMessages({
  success: {
    id: 'passwordReset.sent.success',
    defaultMessage: 'Success!',
  },
  linkSent: {
    id: 'passwordReset.sent.linkSent',
    defaultMessage:
      'Further instructions have been sent to your e-mail address.',
  },
  goBack: {
    id: 'passwordReset.sent.goBack',
    defaultMessage: 'Back to login',
  },
});

const SentForm: React.FC<RouteComponentProps> = () => {
  const { formatMessage } = useIntl();

  return (
    <AuthLayout title={formatMessage(messages.success)}>
      <Subtitle>{formatMessage(messages.linkSent)}</Subtitle>
      <BackLink to={ROUTES.LOGIN}>{formatMessage(messages.goBack)}</BackLink>
    </AuthLayout>
  );
};

export default SentForm;
